import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PoliticaPrivacidade.css';

const PoliticaPrivacidade = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="politica-privacidade">
      {/* Header simplificado */}
      <header className="politica-header">
        <div className="container">
          <Link to="/" className="back-link">
            <i className="bi bi-arrow-left"></i> Voltar ao início
          </Link>
        </div>
      </header>

      <main className="politica-content">
        <div className="container">
          <h1>Política de Privacidade</h1>
          <p className="ultima-atualizacao">
            Última atualização: {new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>

          <section className="politica-section">
            <h2>1. Introdução</h2>
            <p>
              A <strong>Igreja Evangélica Casa de Oração</strong>, localizada em Hengelo, Países Baixos, 
              está comprometida em proteger a privacidade e os dados pessoais de todos os visitantes 
              do nosso site e membros da nossa comunidade.
            </p>
            <p>
              Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos 
              suas informações pessoais, em conformidade com o <strong>Regulamento Geral de Proteção 
              de Dados (GDPR/AVG)</strong> da União Europeia.
            </p>
          </section>

          <section className="politica-section">
            <h2>2. Responsável pelo Tratamento de Dados</h2>
            <div className="info-box">
              <p><strong>Igreja Evangélica Casa de Oração</strong></p>
              <p>Pastora Presidente: Rita Platenkamp</p>
              <p>Endereço: Slachthuisweg 1B, Hengelo (De Rots) - Países Baixos</p>
              <p>Telefone: +31 6 1514 2684</p>
            </div>
          </section>

          <section className="politica-section">
            <h2>3. Dados que Coletamos</h2>
            <p>Podemos coletar os seguintes tipos de dados pessoais:</p>
            
            <h3>3.1 Dados fornecidos por você:</h3>
            <ul>
              <li>Informações de contato via WhatsApp</li>
              <li>Informações relacionadas a doações (quando aplicável)</li>
              <li>Confirmações de presença em eventos</li>
            </ul>

            <h3>3.2 Dados coletados automaticamente:</h3>
            <ul>
              <li>Preferência de consentimento de cookies (armazenada localmente no seu navegador)</li>
              <li>Cookies técnicos necessários para o funcionamento do site</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>4. Finalidade do Tratamento</h2>
            <p>Utilizamos seus dados pessoais para as seguintes finalidades:</p>
            <ul>
              <li><strong>Comunicação:</strong> Responder a mensagens e pedidos de contato</li>
              <li><strong>Eventos:</strong> Gerenciar inscrições e confirmações de presença</li>
              <li><strong>Doações:</strong> Processar e confirmar contribuições financeiras</li>
              <li><strong>Obrigações legais:</strong> Cumprir requisitos legais e fiscais</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>5. Base Legal para o Tratamento</h2>
            <p>O tratamento dos seus dados pessoais é baseado em:</p>
            <ul>
              <li><strong>Consentimento (Art. 6(1)(a) GDPR):</strong> Quando você nos fornece seus dados voluntariamente</li>
              <li><strong>Interesse legítimo (Art. 6(1)(f) GDPR):</strong> Para manter nossa comunidade informada e funcionando</li>
              <li><strong>Obrigação legal (Art. 6(1)(c) GDPR):</strong> Para cumprir obrigações fiscais relacionadas a doações</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>6. Cookies</h2>
            <p>Nosso site utiliza cookies para:</p>
            <ul>
              <li><strong>Cookies essenciais:</strong> Necessários para o funcionamento básico do site</li>
              <li><strong>Cookies de preferência:</strong> Lembrar suas escolhas (como aceitar esta política)</li>
            </ul>
            <p>
              Você pode gerenciar suas preferências de cookies através das configurações do seu navegador. 
              Note que desativar certos cookies pode afetar a funcionalidade do site.
            </p>
          </section>

          <section className="politica-section">
            <h2>7. Compartilhamento de Dados</h2>
            <p>
              <strong>Não vendemos, alugamos ou compartilhamos</strong> seus dados pessoais com terceiros 
              para fins comerciais.
            </p>
            <p>Seus dados podem ser compartilhados apenas:</p>
            <ul>
              <li>Com provedores de serviço essenciais (hospedagem do site, processamento de pagamentos)</li>
              <li>Quando exigido por lei ou autoridades competentes</li>
              <li>Com seu consentimento explícito</li>
            </ul>

            <h3>7.1 Serviços de terceiros utilizados:</h3>
            <ul>
              <li><strong>WhatsApp:</strong> Para comunicação direta (política própria do WhatsApp/Meta)</li>
              <li><strong>Tikkie:</strong> Para processamento de doações (política própria do ABN AMRO)</li>
              <li><strong>YouTube:</strong> Para transmissões de cultos (política própria do Google)</li>
              <li><strong>Instagram:</strong> Para divulgação (política própria da Meta)</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>8. Retenção de Dados</h2>
            <p>Mantemos seus dados pessoais apenas pelo tempo necessário:</p>
            <ul>
              <li><strong>Dados de contato:</strong> Enquanto houver relacionamento ativo com a igreja</li>
              <li><strong>Dados de doações:</strong> 7 anos (conforme exigência fiscal holandesa)</li>
              <li><strong>Dados de eventos:</strong> 1 ano após o evento</li>
              <li><strong>Cookies:</strong> Conforme especificado no banner de consentimento</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>9. Seus Direitos (GDPR)</h2>
            <p>De acordo com o GDPR, você tem os seguintes direitos:</p>
            <ul>
              <li><strong>Direito de acesso:</strong> Solicitar cópia dos seus dados pessoais</li>
              <li><strong>Direito de retificação:</strong> Corrigir dados incorretos ou incompletos</li>
              <li><strong>Direito ao apagamento:</strong> Solicitar a exclusão dos seus dados ("direito ao esquecimento")</li>
              <li><strong>Direito à portabilidade:</strong> Receber seus dados em formato estruturado</li>
              <li><strong>Direito de oposição:</strong> Opor-se ao tratamento dos seus dados</li>
              <li><strong>Direito de retirar consentimento:</strong> A qualquer momento, sem afetar a licitude do tratamento anterior</li>
            </ul>
            <p>
              Para exercer qualquer destes direitos, entre em contato conosco através do telefone 
              <strong> +31 6 1514 2684</strong> ou pelo WhatsApp.
            </p>
          </section>

          <section className="politica-section">
            <h2>10. Segurança dos Dados</h2>
            <p>Implementamos medidas técnicas e organizacionais para proteger seus dados:</p>
            <ul>
              <li>Conexão segura (HTTPS) em todo o site</li>
              <li>Acesso restrito aos dados apenas a pessoas autorizadas</li>
              <li>Backups regulares e seguros</li>
            </ul>
          </section>

          <section className="politica-section">
            <h2>11. Menores de Idade</h2>
            <p>
              Nosso site é aberto a pessoas de todas as idades e não requer cadastro ou criação de conta. 
              Para menores de 16 anos que desejem enviar dados pessoais através dos nossos formulários de contato, 
              recomendamos que o façam com o conhecimento dos pais ou responsáveis legais, conforme o GDPR.
            </p>
          </section>

          <section className="politica-section">
            <h2>12. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta Política de Privacidade periodicamente. Quaisquer alterações 
              significativas serão comunicadas através do nosso site. Recomendamos que você revise 
              esta página regularmente.
            </p>
          </section>

          <section className="politica-section">
            <h2>13. Autoridade de Proteção de Dados</h2>
            <p>
              Se você não estiver satisfeito com a forma como tratamos seus dados, você tem o direito 
              de apresentar uma reclamação à autoridade de proteção de dados holandesa:
            </p>
            <div className="info-box">
              <p><strong>Autoriteit Persoonsgegevens</strong></p>
              <p>Website: <a href="https://www.autoriteitpersoonsgegevens.nl" target="_blank" rel="noopener noreferrer">www.autoriteitpersoonsgegevens.nl</a></p>
              <p>Telefone: +31 70 888 8500</p>
            </div>
          </section>

          <section className="politica-section">
            <h2>14. Contato</h2>
            <p>
              Para dúvidas sobre esta Política de Privacidade ou sobre o tratamento dos seus dados, 
              entre em contato:
            </p>
            <div className="info-box">
              <p><strong>Igreja Evangélica Casa de Oração</strong></p>
              <p><i className="bi bi-telephone-fill"></i> +31 6 1514 2684</p>
              <p><i className="bi bi-whatsapp"></i> <a href="https://wa.link/rntc9u" target="_blank" rel="noopener noreferrer">WhatsApp</a></p>
            </div>
          </section>

          <div className="politica-footer">
            <Link to="/" className="btn-voltar">
              <i className="bi bi-house-fill"></i> Voltar à Página Inicial
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PoliticaPrivacidade;
